export const OWN_COLUMN_KEYS = new Set([
  "customer_name",
  "business_unit_name",
  "job_completed_on",
  "payout_amount",
]);
